module.exports = __webpack_public_path__ + "static/chris-163a35b47f133cabc1ccce62786678bf.png";